import { render, staticRenderFns } from "./AccountUnificationBulkAction.vue?vue&type=template&id=e072c780&scoped=true"
import script from "./AccountUnificationBulkAction.vue?vue&type=script&lang=js"
export * from "./AccountUnificationBulkAction.vue?vue&type=script&lang=js"
import style0 from "./AccountUnificationBulkAction.vue?vue&type=style&index=0&id=e072c780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e072c780",
  null
  
)

export default component.exports